import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../auth/authentication.service';
import { Router } from '@angular/router';
import { UserVistaPermissions } from 'src/app/Model/UserPermission.Model';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit {
  public permissionDataVisualisation: boolean = true;
  public permissionDataParameters: boolean = true;
  public permissionSettings: boolean = true;
  usersPermissions: UserVistaPermissions[];
  CurrentuserPermissions: any;
  BaseUrl: string = localStorage.getItem('Vista_urlapi');

  constructor(
    public authenticationService: AuthenticationService,
    private router: Router
  ) {}



  ngOnInit() {
    this.authenticationService.isLoadingBehaviour$.subscribe(
      (response) => {
        if(response == false) {
          this.PermissionDataVisualisation();
      this.PermissionDataParameters()
      this.PermissionSettings()
        }
      }
    )
  }

  ShowDataParameters() {
    this.router.navigate(['data-parameters']);
  }
  ShowDataVisualization() {
    this.router.navigate(['data-visualisation']);
  }
  ShowSetting() {
    this.router.navigate(['settings']);
  }
  PermissionDataVisualisation() {

    if (
      this.authenticationService.UserPermission.MarketCoMasterData == true ||
      this.authenticationService.UserPermission.FinacialInformationData ==
        true ||
      this.authenticationService.UserPermission.EposInformationData == true ||
      this.authenticationService.UserPermission.PromotionPlansData == true ||
      this.authenticationService.UserPermission.AdvancedData == true
    ) {
      this.permissionDataVisualisation = true;
    } else {
      this.permissionDataVisualisation = false;
    }
  }
  PermissionDataParameters() {
    if (
      this.authenticationService.UserPermission.FinacialParameters == true ||
      this.authenticationService.UserPermission.PromotionParameters == true ||
      this.authenticationService.UserPermission.DailyRosFirstDayParameters ==
        true ||
      this.authenticationService.UserPermission.SeasonalitesParameters ==
        true ||
      this.authenticationService.UserPermission.EposManagementParameters ==
        true ||
      this.authenticationService.UserPermission.AdvancedParameters == true ||
      this.authenticationService.UserPermission.AdditionalParameters == true ||
      this.authenticationService.UserPermission.PricingParameters == true ||
      this.authenticationService.UserPermission.CompetitionParameters == true
    ) {
      this.permissionDataParameters = true;
    } else {
      this.permissionDataParameters = false;
    }
  }
  PermissionSettings() {
    if (
      this.authenticationService.UserPermission.Settings == true ||
      this.authenticationService.UserPermission.Monitoring == true ||
      this.authenticationService.CoherencyTest === 1
    ) {
      this.permissionSettings = true;
    } else {
      this.permissionSettings = false;
    }
  }
}
